import { render, staticRenderFns } from "./sampleAnalysisDetails.vue?vue&type=template&id=2fdf607e"
import script from "./sampleAnalysisDetails.ts?vue&type=script&lang=js&external"
export * from "./sampleAnalysisDetails.ts?vue&type=script&lang=js&external"
import style0 from "./sampleAnalysisDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports